import PropTypes from 'prop-types';
import { TableRow as BdsTableRow } from '@bevy/bevy-design-system';

import styles from './styles.module.less';

/**
 * This adjusts the table row to inherit the background color of the table
 * This helps keeping the sticky cell to always have a background color that
 * matches the row where it is placed.
 *
 * Why?
 * - Because if the sticky cell does not have a background color, it won't hide the table content it is overlapping.
 *
 * Tech-debt: we should remove this component after we make the TableRow component has the CSS property `background-color: inherit;`
 */
export default function TableRow({ children }) {
  return (
    <div className={styles.tableRow}>
      <BdsTableRow>{children}</BdsTableRow>
    </div>
  );
}

TableRow.propTypes = {
  children: PropTypes.node,
  stickyAlign: PropTypes.oneOf(['left', 'right']),
};
